import { useQuery } from 'data-fetching-client';
import { getIsPaidPortal } from 'onboarding-scopes';
import { GET_USER_INFO } from 'pricing-pages-api/user/queries';
const DIRECTORY_USER = 'partner-join-program';
const PARTNER_LEAD_REGISTRATION = 'partner-lead-registration';
export const useUserInfo = () => {
  var _userInfoQuery$data;
  const userInfoQuery = useQuery(GET_USER_INFO);
  return ((_userInfoQuery$data = userInfoQuery.data) === null || _userInfoQuery$data === void 0 ? void 0 : _userInfoQuery$data.userInfo) || undefined;
};
export const useIsInAppAuth = () => {
  const userInfo = useUserInfo();
  return !!(userInfo !== null && userInfo !== void 0 && userInfo.user);
};
export const useIsInternalHubspotUser = () => {
  var _userInfo$user;
  const userInfo = useUserInfo();
  return (userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 || (_userInfo$user = _userInfo$user.email) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.endsWith('@hubspot.com')) || false;
};
export const useIsPaidPortal = () => {
  var _userInfo$user2;
  const userInfo = useUserInfo();
  return getIsPaidPortal((userInfo === null || userInfo === void 0 || (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2.scopes) || []);
};
export const useIsFreePortal = () => {
  return !useIsPaidPortal();
};
export const usePortalGates = () => {
  const userInfo = useUserInfo();
  return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) || [];
};
export const useIsSeatsUser = () => {
  var _userInfo$user3;
  const userInfo = useUserInfo();
  return (userInfo === null || userInfo === void 0 || (_userInfo$user3 = userInfo.user) === null || _userInfo$user3 === void 0 || (_userInfo$user3 = _userInfo$user3.scopes) === null || _userInfo$user3 === void 0 ? void 0 : _userInfo$user3.includes('seats-access')) || false;
};
export const useIsPartnerProgramEligible = () => {
  var _userInfo$user4;
  const userInfo = useUserInfo();
  const scopes = userInfo === null || userInfo === void 0 || (_userInfo$user4 = userInfo.user) === null || _userInfo$user4 === void 0 ? void 0 : _userInfo$user4.scopes;
  const isDirectoryUser = scopes === null || scopes === void 0 ? void 0 : scopes.some(scope => scope === DIRECTORY_USER);
  const isPartner = scopes === null || scopes === void 0 ? void 0 : scopes.some(scope => scope === PARTNER_LEAD_REGISTRATION);
  return Boolean(isDirectoryUser && !isPartner);
};